import { render, staticRenderFns } from "./card-success.vue?vue&type=template&id=bcc880ca&"
import script from "./card-success.vue?vue&type=script&lang=js&"
export * from "./card-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports